export function createAbortError(reason?: string): DOMException {
	return new DOMException(
		`signal is aborted ${reason ?? "without reason"}`,
		"AbortError"
	);
}

export function ensureNotCancelled(signal: AbortSignal | undefined, additionalMessage?: string): void {
	if (signal && signal.aborted) {
		throw createAbortError(additionalMessage);
	}
}

export function isCancelledError(error: unknown): error is DOMException {
	return error instanceof DOMException
		&& (error.name === "AbortError" || error.name === "TimeoutError");
}
